import { render, staticRenderFns } from "./TableCol.vue?vue&type=template&id=7a6930bd&scoped=true"
import script from "./TableCol.vue?vue&type=script&lang=js"
export * from "./TableCol.vue?vue&type=script&lang=js"
import style0 from "./TableCol.vue?vue&type=style&index=0&id=7a6930bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6930bd",
  null
  
)

export default component.exports